import { DefaultPageHeader } from 'layouts';
import { Card, Skeleton } from 'ui';
import { EventsSlider, useChannelsEventsInfiniteQuery } from 'features/events';
import { ChannelsEmpty, EntityList } from '../components';
import { useOrganizationRequestContent } from '../hooks';

type P = {
  getPathToEventDetail: (id: string) => string;
  navigateToCalendar: () => Promise<void>;
  organizationId: string;
};

const ChannelsEvents = ({ getPathToEventDetail, navigateToCalendar, organizationId }: P) => {
  const { allOrganizations, isLoadingOrganizations, requestOrganizationId } = useOrganizationRequestContent({
    organizationId,
  });

  const {
    data: allEventsData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useChannelsEventsInfiniteQuery({
    filter: { organizationId: requestOrganizationId, scope: 'channels' },
    pagination: { pageSize: 12 },
  });

  const allEvents = allEventsData?.pages.flat();

  return (
    <>
      <DefaultPageHeader title="Events" />
      {isLoadingOrganizations || isLoadingAll || !allEvents || !allOrganizations ? (
        <Skeleton active paragraph={{ rows: 16 }} />
      ) : (
        <>
          <EventsSlider
            controls={{ title: 'Featured' }}
            getPathToEventDetail={getPathToEventDetail}
            query={{ filter: { organizationId: requestOrganizationId, scope: 'channels' } }}
          />
          <Card title={<Card.Title level={2}>All</Card.Title>}>
            <EntityList
              empty={<ChannelsEmpty navigateToJoined={navigateToCalendar} scope="events" />}
              entities={allEvents.map((event) => ({
                data: event,
                type: 'Event',
              }))}
              fetchNextPage={fetchNextPage}
              getPathToEntityDetail={getPathToEventDetail}
              hasNextPage={hasNextPage}
              isFetching={isFetchingAll}
              isLoading={isLoadingAll}
            />
          </Card>
        </>
      )}
    </>
  );
};

export default ChannelsEvents;
